import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ canceladas, finalizadas, suspenca, ativas }) => {
  const total = canceladas + finalizadas + suspenca + ativas;

  const data = {
    labels: ['Canceladas', 'Finalizadas', 'Suspensas', 'Ativas'],
    datasets: [
      {
        label: 'Tarefas',
        data: [canceladas, finalizadas, suspenca, ativas],
        backgroundColor: ['#004376', '#3f8600', '#ffb300', '#3990d3'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: '50%', // deixa mais "donut"
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const porcentagens = [
    { label: 'Canceladas', value: canceladas, color: '#004376' },
    { label: 'Finalizadas', value: finalizadas, color: '#3f8600' },
    { label: 'Suspensas', value: suspenca, color: '#ffb300' },
    { label: 'Ativas', value: ativas, color: '#3990d3' },
  ];

  return (
    <div style={{alignItems: 'center'}}>
      {/* Gráfico */}
      <div style={{ width: '130px', height: '205px', margin: "0 auto"}}>
        <Doughnut data={data} options={options} />
      </div>

      {/* Cards de porcentagem */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {porcentagens.map((item) => (
          <div
            key={item.label}
            style={{
              background: '#fff',
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: '10px',
              padding: '10px 15px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              minWidth: '110px',
              fontSize: 11
            }}
          >
            <div style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: item.color
            }} />
            <strong style={{ flex: 1 }}>{item.label}</strong>
            <span style={{ fontWeight: 600, color: item.color }}>
              {((item.value / total) * 100).toFixed(1)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoughnutChart;
